"use client";
import { Box } from "../../../core/Box/Box.mjs";
import Loader_module_default from "../Loader.module.mjs";
import cx from "clsx";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Loader/loaders/Oval.tsx
const Oval = ({ className, ...others }) => /* @__PURE__ */ jsx(Box, {
	component: "span",
	className: cx(Loader_module_default.ovalLoader, className),
	...others
});
Oval.displayName = "@mantine/core/Oval";
//#endregion
export { Oval };

//# sourceMappingURL=Oval.mjs.map